<template>
  <div class="orders-container">
    <div class="container">
     <div class="orders-content">
      <!-- <left-panel :current-index="3"></left-panel> -->
      <div class="orders-list">
        <div class="orders-list-header">
          <div class="orders-list-header-left">
            <div class="orders-list-header-left-title">设备管理</div>
            <div class="orders-list-header-left-descript">最多可以设置 3 个常用设备，达到上限后每 7 天只能修改一次</div>
          </div>
          <div class="orders-list-header-right">
            <p @click="delEquipmenFn">删除设备</p>
            <span>全选</span>
            <input type="checkbox" v-model="checkedIpt">
          </div>
        </div>
        <div class="orders-list-container">
          <div class="orders-list-container-item" v-for="(item,index) in equipmentList" :key="item.created_at">
            <div class="orders-list-container-left">
              <div class="orders-list-container-left-name">{{item.device_name}}</div>
              <div class="orders-list-container-left-date">{{item.updated_at | filDate}}</div>
            </div>
            <div class="orders-list-container-right">
              <input type="checkbox" v-if="!item.deleted_at" :checked="item.checked" @click="clickIptFn(index)">
              <span v-else>已删除</span>
            </div>
          </div>
        </div>
      </div>
     </div>


    </div>
  </div>
</template>

<script>
	import api from '@/api'
  import moment from 'moment'
	export default {
		name: 'orders',
		data () {
			return {
        timer: null,
        pageAndSize: {page: 1}, // 获取全部登录过的设备传递的参数
        equipmentList: [], // 获取全部登录过的设备数组
        alreadyDelEquipmentList: [] // 准备要删除的设备号数组
			}
		},
    created(){
      this.getEquipmentListFn() // 获取登录过的设备数组
    },
    methods: {
      // 初次渲染获取设备数组（不管删了没删的）
      async getEquipmentListFn() {
        try{
          let res = await api.Equipment.getCredibleEquipment(this.pageAndSize)
          if(res.code !== 1000) return
          this.equipmentList = res.data.devices.map(it => {
            if(!it.deleted_at) {
              return {...it,checked: false}
            }else {
              return {...it}
            }
          })
          console.log(this.equipmentList);
        }catch(err) {
          return err
        }
      },
      // 点击改变每一个复选框的值
      clickIptFn(idx) {
        this.equipmentList[idx].checked = !this.equipmentList[idx].checked
        this.alreadyDelEquipmentList = this.equipmentList.filter(it => !it.deleted_at).filter(it => it.checked).map(it => it.device_number)
        console.log(this.alreadyDelEquipmentList)
        
      },
      // 删除设备的函数
      delEquipmenFn() {
        clearTimeout(this.timer)
        this.timer = setTimeout(async () => {
          let res = {}
          if(this.alreadyDelEquipmentList.length === 0) {
            return this.$message.error('请选择要删除的设备')
          }else if(this.alreadyDelEquipmentList.length === 1) {
            try{
              res = await api.Equipment.delCredibleEquipment(this.alreadyDelEquipmentList[0])
            }catch(err) {
              return err
            }
          }else {
            try{
              res = await api.Equipment.batchDelCredibleEquipment(this.alreadyDelEquipmentList)
            }catch(err) {
              return err
            }
          }
          if(res.code !== 1000) {
            return this.$message.error(res.message)
          }else {
            this.$message.success(res.message)
            this.getEquipmentListFn()
          }
        },700)

      }
		},
		computed: {
      checkedIpt: {
        get() {
          return this.equipmentList.filter(it => !it.deleted_at).every(it => it.checked)
        },
        set(val) {
          this.equipmentList = this.equipmentList.map(it => {
            if(!it.deleted_at) {
              return {...it,checked: val}
            }else {
              return {...it}
            }
          }) 
          this.alreadyDelEquipmentList = this.equipmentList.filter(it => !it.deleted_at).filter(it => it.checked).map(it => it.device_number)
          console.log(this.alreadyDelEquipmentList)
          
        }
      }
    },
    filters: {
      filDate(val) {
        return moment(val).format('YYYY.MM.DD HH:mm')
      }
    }
	}
</script>

<style lang="scss" scoped>
  @import './index.scss';
</style>
